import { FormatReference } from "./FormatReference";

/**
 * 扱っている情報はFormatSetと似たようなものだが、FormatSetはツリー側で使われる想定のため用途が異なっている
 */
export class FormatGroup {
  public id: number;
  public name: string;
  public isDeleted: boolean;
  public formats: FormatReference[];
}
